import { makeStyles } from 'tss-react/mui';

const useAuthPanelStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 380,
    minHeight: 400,
    [theme.breakpoints.down('md')]: {
      minHeight: 'unset',
      backgroundColor: theme.palette.background.default,
      boxShadow: `0 0 96px 64px ${theme.palette.background.default}`,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(4),
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.spacing(3),
  },
}));

export default useAuthPanelStyles;
